import { useSelector } from 'react-redux'
import { Button } from "reactstrap"
import { RestoreBackupButton } from './components/generic/RestoreBackupButton'
import { TakeBackupButton } from './components/generic/TakeBackupButton'
import { useFightSelectors } from './redux/slices/fight-slice'
import { RootState } from './redux/store'
import { Storage } from './utils/local-storage'
import { assertDefined, expectOneById } from './utils/utils'

type DevToolsProps = {
    lite?: boolean
}

export const DevTools = (props: DevToolsProps): JSX.Element | null => {

    const fightSelectors = useFightSelectors()
    const state = useSelector<RootState, RootState>(state => state)

    const dumpCurrentFightAndSetup = () => {
        const { selectedFightId, selectedSetupId } = state.displayFight

        const fullFight = fightSelectors.getFullFight(selectedFightId)

        assertDefined(selectedSetupId)
        const setup = expectOneById(state.setup.setups, selectedSetupId)

        navigator.clipboard.writeText(JSON.stringify({
            fullFight,
            setup
        }, null, ' '))

        alert(`See clipboard -- This dump can not be imported anywhere, I don't know why we added this :3`)
    }

    const backupCurrentState = () => {
        Storage.writeDebugState({
            fight: state.fight,
            meta: state.meta,
            roster: state.roster,
            setups: state.setup
        })
    }

    const loadLatestBackupState = () => {
        const debugState = Storage.readDebugState()
        Storage.writeState(debugState)
        window.location.reload()
    }

    const resetState = () => {
        setTimeout(() => {
            Storage.dangerous_nukeState()
            window.location.reload()
        }, (1000))
    }

    return (
        <div style={{
            position: 'fixed',
            top: 10,
            right: 10,
            zIndex: 1,
            border: '1px solid silver',
        }}
            className={'p-2 bg-light d-flex flex-column space-my-2 rounded shadow'}
        >
            {props.lite === false && (
                <>
                    <Button size='sm' outline onClick={dumpCurrentFightAndSetup}>
                        {'Copy fight & setup'}
                    </Button>

                    <hr className='w-100 mb-2 mt-0' />

                    <Button size='sm' outline onClick={backupCurrentState}>
                        {'Save snapshot'}
                    </Button>
                    <Button size='sm' color="success" onClick={loadLatestBackupState}>
                        {'Load snapshot'}
                    </Button>

                    <hr className='w-100 mb-2 mt-0' />

                    <Button size='sm' color='danger' onClick={resetState}>
                        {'Wipe all state'}
                    </Button>

                    <hr className='w-100 mb-2 mt-0' />
                </>
            )}

            <div className="d-flex space-mx-2">
                <TakeBackupButton />
                <RestoreBackupButton />
            </div>
        </div>
    )
}
